import styles from "./index.module.css";
import YesIcon from "./yes.svg";
import { useInView } from "react-intersection-observer";

const items = [
  <>
    Отримаєш <strong>сертифікат</strong> в кінці інтенсиву
  </>,
  <>
    Кожен місяць <strong>новий викладач</strong>, не дамо бути в зоні комфорту
  </>,
  <>
    Домашня робота також задається на дні, в які <strong>немає</strong> занять
  </>,
  <>
    Домашня робота перевіряється викладачем <strong>поза уроком</strong>, за
    запитом учнів може бути проаналізована на уроці
  </>,
  <>
    Маленькі групи по <strong>6 студентів</strong>
  </>,
  <>
    Всі заняття <strong>записуються</strong> в разі вашої відсутності
  </>,
];

export default function MoreBlock() {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.25,
  });

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.card}>
          <h2>ЩО ЩЕ?</h2>
          <div
            ref={ref}
            className={[styles.list, inView ? styles.visible : ""].join(" ")}
          >
            {items.map((item, index) => (
              <div className={styles.item} key={index}>
                <img src={YesIcon} alt="" aria-hidden="true" />
                <p>{item}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
